export default __webpack_public_path__ + "static/media/logo.9a37959f.png";